import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DownOutlined } from '@ant-design/icons';

import './faq.scss';

const DropdownItem = ({ item }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleChange = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  return (
    <div className={`landing__faq-item ${isOpen ? 'landing__faq-item--open' : ''}`}>
      <button
        type="button"
        className="landing__faq-question"
        aria-expanded={isOpen}
        onClick={handleChange}
      >
        <span className="landing__faq-text" dangerouslySetInnerHTML={{ __html: item.q }} />
        <DownOutlined className="landing__faq-icon" />
      </button>
      <div className="landing__faq-answer">
        <div dangerouslySetInnerHTML={{ __html: item.a }} />
      </div>
    </div>
  );
};

export const Faq = () => {
  const { t } = useTranslation('faq');
  const faqItems = t('items', { returnObjects: true });

  return (
    <section id="faq" className="landing__faq">
      <h2 className="landing__section-title">{t('title')}</h2>
      <div className="landing__faq-list">
        {faqItems.map((item) => {
          return <DropdownItem key={item.question} item={{ q: item.question, a: item.answer }} />;
        })}
      </div>
    </section>
  );
};
